<template>
  <v-chip
    v-if="loan.status === 'OPEN' && loan.pendingReturnQuantity > 0"
    color="warning"
    small
    @click="handleClick"
  >
    Returning / <pretty-number :value="loan.pendingReturnQuantity" />
  </v-chip>

  <v-chip
    v-else-if="loan.pendingBuyInQuantity > 0"
    color="orange darken-2"
    small
    @click="handleClick"
  >
    Buying-in / <pretty-number :value="loan.pendingBuyInQuantity" />
  </v-chip>

  <v-chip v-else :color="loanStatuses[loan.status].color" small @click="handleClick">
    {{ loanStatuses[loan.status].label }}
  </v-chip>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import Component from 'vue-class-component';
import { loanStatuses } from '@/utils/api/loans';
import { OpenLoan } from '@/modules/common/models';

@Component({
  props: {
    loan: Object as PropType<OpenLoan>,
    click: Function as PropType<(loan: OpenLoan) => void>,
  },
})
export default class LoanStatusChip extends Vue {
  protected readonly loan!: OpenLoan;
  protected readonly click!: (loan: OpenLoan) => void;
  protected loanStatuses = loanStatuses;

  protected handleClick(): void {
    if (this.click) {
      this.click(this.loan);
    } else {
      this.$emit('click', this.loan);
    }
  }
}
</script>
<style lang="scss" scoped>
.v-chip {
  width: 4rem;
  min-width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: lowercase;
}
</style>
